import { render, staticRenderFns } from "./rolesTree.vue?vue&type=template&id=af543dc8&scoped=true"
import script from "./rolesTree.vue?vue&type=script&lang=js"
export * from "./rolesTree.vue?vue&type=script&lang=js"
import style0 from "./rolesTree.vue?vue&type=style&index=0&id=af543dc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af543dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af543dc8')) {
      api.createRecord('af543dc8', component.options)
    } else {
      api.reload('af543dc8', component.options)
    }
    module.hot.accept("./rolesTree.vue?vue&type=template&id=af543dc8&scoped=true", function () {
      api.rerender('af543dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/setting/rolesTree.vue"
export default component.exports